
import { defineComponent } from "vue";
import { eventBus } from "../../event";

export default defineComponent({
  name: "Loader",
  data() {
    return {
      showLoadingAnimation: false,
      text: "",
    };
  },
  mounted() {
    eventBus.on("loader-start", (text: string) => {
      this.text = text;
      this.showLoadingAnimation = true;
    });
    eventBus.on("loader-finish", () => {
      this.showLoadingAnimation = false;
      this.text = "";
    });
  },
});
